import React from "react";
import { getYoutubeId } from "./utils";
import styles from "./youtubefacade.module.css";

const YouTubeFacade: React.FC<{
  src: string;
  title?: string;
  onClick: () => void;
  aspectRatio: number;
}> = ({ src, title, onClick, aspectRatio }) => {
  const videoId = getYoutubeId(src);

  return (
    <div className={styles.container}>
      <picture>
        <source
          srcSet={`https://i.ytimg.com/vi_webp/${videoId}/sddefault.webp`}
          type="image/webp"
        />
        <source
          srcSet={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
          type="image/jpeg"
        />
        <img
          className={styles.facade}
          src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
          style={{ aspectRatio }}
          alt={title || ""}
          loading="lazy"
        />
      </picture>
      <button className={styles.playButton} type="button" onClick={onClick}>
        <span className={styles.playButtonText}>Play</span>
      </button>
    </div>
  );
};

export default YouTubeFacade;
